import { configureStore } from '@reduxjs/toolkit'
import mapReducer from '@shared/slices/mapSlice'
import rtlsReducer from '@shared/slices/rtlsSlice'
import viewerReducer from '@shared/slices/viewerSlice'
import uiReducer from '@shared/slices/uiSlice'
import activityReducer from '@shared/slices/activitySlice'

export const store = configureStore({
  reducer: {
    map: mapReducer,
    rtls: rtlsReducer,
    viewer: viewerReducer,
    ui: uiReducer,
    activity: activityReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
